import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cdd5deb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "InformationDetail_operationWrapper" }
const _hoisted_2 = { class: "paging_container" }
const _hoisted_3 = { class: "InformationDetail_Container" }
const _hoisted_4 = { class: "InformationDetail_Contents" }
const _hoisted_5 = { class: "Info_Container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "info_tit js-info_accodion" }
const _hoisted_8 = { class: "info_date" }
const _hoisted_9 = { class: "info_txt" }
const _hoisted_10 = ["innerHTML"]

import { ref } from "vue";
import { useStore } from "vuex";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import axios from "axios";
import { Notyf } from "notyf";
import { useRouter } from "vue-router";
import BtnGreen from "@/components/atoms/button/BtnGreen.vue";
import Paginate from "vuejs-paginate-next";

type InformationList = typeof informationList.value[0];

export default /*#__PURE__*/_defineComponent({
  __name: 'InformationDetail',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props, { emit: __emit }) {

const notyf = new Notyf();

const props = __props;
const store = useStore();
const router = useRouter();

const emit = __emit;
emit("showGlobalHeader");

// ぱんくずヘッダー
const currentPathList = [{ name: "ダッシュボード" }, { name: "お知らせ一覧" }];

// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 20;
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);
// 総ページ数
const numberOfTotalPage = ref(0);
// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  getInformationList();
};

// お知らせの取得------------------------------------------------------
// お知らせ一覧を取得
const informationList = ref([
  {
    contents: "",
    id: -1,
    registeredAt: "",
    scheduledEndAt: "",
    scheduledStartAt: "",
    title: "",
    isOpen: false,
  },
]);
const getInformationList = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/information/?page=${currentPage.value}&numberOfDisplay=${dataPerPage}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    informationList.value.splice(0);
    informationList.value = res.data.display;
    informationList.value.forEach((info) => {
      info.isOpen = false;
    });
    numberOfTotalData.value = res.data.size;
    firstCount.value = res.data.firstCount;
    finalCount.value = res.data.finalCount;
    getTotalPage();
  } catch (error) {
    console.log(error);
    alert("最新お知らせを取得できませんでした");
  }
};
getInformationList();
// 表示用日付生成
const convertOnlyDate = (registerDate: string | null) => {
  if (typeof registerDate === "string") {
    const targetDate = new Date(registerDate);
    const year = targetDate.getFullYear();
    const month = (targetDate.getMonth() + 1).toString().padStart(2, "0");
    const date = targetDate.getDate().toString().padStart(2, "0");
    return `${year}/${month}/${date}`;
  } else {
    return null;
  }
};

// 戻るボタン
const backToDashboard = () => {
  router.push("/dashboard");
};

return (_ctx: any,_cache: any) => {
  const _component_slide_up_down = _resolveComponent("slide-up-down")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createElementVNode("div", {
      class: _normalizeClass(["InformationDetail", {
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
    }, [
      _createVNode(BtnGreen, {
        class: "InformationDetail_BtnGreen",
        onClick: backToDashboard
      }, {
        default: _withCtx(() => [
          _createTextVNode("ホームに戻る")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Paginate), {
            "page-count": numberOfTotalPage.value,
            "hide-prev-next": true,
            "page-range": 3,
            "prev-text": '<',
            "next-text": '>',
            "container-class": 'pagination',
            "page-class": 'page-item',
            "page-link-class": 'page-item--link',
            "active-class": 'page-item--active',
            "click-handler": onClickPage,
            "force-page": currentPage.value
          }, null, 8, ["page-count", "force-page"]),
          _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
            [_vShow, informationList.value.length]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(informationList.value, (info) => {
              return (_openBlock(), _createElementBlock("div", {
                key: info.id,
                onClick: ($event: any) => (info.isOpen = !info.isOpen),
                class: "Info_Contents"
              }, [
                _createElementVNode("h4", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(convertOnlyDate(info.registeredAt)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(info.title), 1)
                  ])
                ]),
                _createVNode(_component_slide_up_down, {
                  active: info.isOpen,
                  duration: 500
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "info_content user_info_content",
                      innerHTML: info.contents
                    }, null, 8, _hoisted_10)
                  ]),
                  _: 2
                }, 1032, ["active"])
              ], 8, _hoisted_6))
            }), 128))
          ])
        ])
      ])
    ], 2)
  ], 64))
}
}

})